import { theme } from "../../../App";
const styles = () => ({
  questionWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  vidoeAndImageContainer: {
    textAlign: "center",
    width: "100%",
    marginTop: 24,
  },
  field: {
    width: "99%",
  },

  helperText: {
    flexGrow: 50,
  },
  imageContentData: {
    backgroundColor: "#e6dede",
    minHeight: 200,
    minWidth: 90,
    [theme.breakpoints.up("sm")]: {
      minHeight: 360,
      minWidth: 160,
    },
    [theme.breakpoints.up("md")]: {
      minHeight: 560,
      minWidth: 250,
    },
  },
  videoContentData: {
    minHeight: 200,
    [theme.breakpoints.up("sm")]: {
      minHeight: 360,
    },
    [theme.breakpoints.up("md")]: {
      minHeight: 560,
    },
  },
  uploadContainer: {
    display: "flex",
    height: 200,
    border: "2px dashed #dadce0",
    borderRadius: 8,
    padding: "0 20px",
    width: "100%",
  },
  imageUpload: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    "&>input": {
      display: "none",
    },
  },
  title: {
    color: "#333333",
    fontSize: 14,
    textAlign: "center",
    [theme.breakpoints.up("sm")]: {
      fontSize: 16,
    },
  },
  recommended: {
    color: "#6d6e71",
    fontSize: 12,
    marginTop: 2,
  },
  showPreview: {
    display: "flex",
    flexDirection: "column",
    textDecoration: "underline",
    flex: 1,
    alignItems: "center",
  },
  showPreviewMedia: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: 18,
  },
  clearFields: {
    fontSize: 14,
    color: "#000000",
    marginLeft: 10,
    cursor: "pointer",
  },
  videoLinkInput: {
    width: "100%",
    marginTop: 24,
  },
  contentPlaceHolder: {
    objectFit: "fill",
    marginTop: 32,
    backgroundColor: "#e6dede",
    width: 200,
    height: 110,
  },
  contentPlaceHolderMedia: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    paddingLeft: "17px",
    width: "100%",
  },
  contentPlaceHolderMediaProgress: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    paddingLeft: "17px",
    width: "100%",
    color: "#00000066",
  },
  contentUploadLoader: {
    position: "absolute",
    top: "55%",
    left: "50%",
    height: "45px",
    width: "45px",
    transform: "translate(-50%, -50%)",
    opacity: "0.7",
  },
  disabled: {
    backgroundColor: "#cccccc",
  },
  videoLinkErro: {
    color: "#f44336",
  },
  uploadFailureMsg: {
    color: "#f44336",
  },
  photoLibraryIcon: {
    color: "#0071CE",
    fontSize: 40,
    cursor: "pointer",
    "&:disabled": {
      cursor: "none",
    },
  },

  photoLibraryIconProgress: {
    color: "#80B8EE",
    fontSize: 40,
    cursor: "pointer",
    "&:disabled": {
      cursor: "none",
    },
  },

  dragAndDroptext: {
    marginBottom: 4,
  },
  browseFileText: {
    color: "#0071ce;",
    textDecoration: "underline",
  },
  mediaAnswerDiv: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    paddingTop: "40px",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  uploadContainerMedia: {
    display: "flex",
    border: "2px dashed #dadce0",
    borderRadius: 8,
    padding: "0 20px",
    height: 164,
    //width: "50%",
  },
  uploadContainerMediaFailure: {
    display: "flex",
    border: "2px dashed #f44336",
    borderRadius: 8,
    padding: "0 20px",
    height: 164,
    //width: "50%",
  },
  testSize: {
    fontSize: "10px",
    fontWeight: 400,
    color: "#000000B2",
    float: "right",
  },
  testFile: {
    width: "50%",
    maxHeight: 240,
    overflowY: "auto",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  testFileSingle: {
    width: "100%",
    height: 240,
  },
  mediaContainer: {
    width: "50%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  mediaContainerSingle: {
    width: "100%",
  },
  displaySize: {
    display: "flex",
    flexDirection: "row",
    color: "#6D6E71",
  },
  displayText: {
    width: "50%",
  },
  displaySizeLeft: {
    width: "50%",
    textAlign: "right",
  },
  errorText: {
    color: "#cb2022",
    float: "right",
    fontSize: 12,
    [theme.breakpoints.up("md") && theme.breakpoints.down("lg")]: {
      paddingLeft: 0,
    },
    [theme.breakpoints.down("md")]: {
      paddingLeft: 0,
    },
  },
  errorTextWrong: {
    color: "#cb2022",
    fontSize: 12,
    [theme.breakpoints.up("md") && theme.breakpoints.down("lg")]: {
      paddingLeft: 0,
    },
    [theme.breakpoints.down("md")]: {
      paddingLeft: 0,
    },
  },
});

export default styles;
